module.exports = __webpack_public_path__ + "../resources/img/ic_minus_gray100.4256cb99.svg";